import styled from 'styled-components';

import CardRef from '../../../../components/Card';

export const Container = styled(CardRef)`
  padding: 10px 15px !important;
`;
